function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M53.38 51.84c-4.36-7.18-9.66-8.71-12.57-8.71s-4.53 1.45-8.72 1.45-5.81-1.45-8.72-1.45-8.2 1.53-12.56 8.71",
  fill: "none",
  stroke: "currentColor",
  strokeMiterlimit: 10,
  strokeWidth: 4.66
});

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 32.09,
  cy: 24.55,
  r: 9.69,
  fill: "none",
  stroke: "currentColor",
  strokeMiterlimit: 10,
  strokeWidth: 4.66
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 32.09,
  cy: 31.97,
  r: 29.39,
  fill: "none",
  stroke: "currentColor",
  strokeMiterlimit: 10,
  strokeWidth: 4.66
});

function SvgLogin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64"
  }, props), _ref, _ref2, _ref3);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA2NCA2NCI+CiAgICA8cGF0aCBkPSJNNTMuMzgsNTEuODRjLTQuMzYtNy4xOC05LjY2LTguNzEtMTIuNTctOC43MXMtNC41MywxLjQ1LTguNzIsMS40NS01LjgxLTEuNDUtOC43Mi0xLjQ1LTguMiwxLjUzLTEyLjU2LDguNzEiIGZpbGw9Im5vbmUiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIHN0cm9rZS13aWR0aD0iNC42NiIvPgogICAgPGNpcmNsZSBjeD0iMzIuMDkiIGN5PSIyNC41NSIgcj0iOS42OSIgZmlsbD0ibm9uZSIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgc3Ryb2tlLXdpZHRoPSI0LjY2Ii8+CiAgICA8Y2lyY2xlIGN4PSIzMi4wOSIgY3k9IjMxLjk3IiByPSIyOS4zOSIgZmlsbD0ibm9uZSIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgc3Ryb2tlLXdpZHRoPSI0LjY2Ii8+Cjwvc3ZnPg==";
export { SvgLogin as ReactComponent };